import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Calendar from 'react-calendar';
import ScheduleDay from './ScheduleDay/ScheduleDay';
import { toDateKey } from './constants';
import { dayAttendance } from '../ScheduleV2/scheduleState';
import 'react-calendar/dist/Calendar.css';
import './schedule-month.styles.scss';

const LOCALE = 'uk-UA';

const ScheduleMonth = ({
  dates,
  activeStartDate,
  selectedDate,
  handleClick,
  setActiveStartDate,
  markAttendance,
}) => {
  const today = toDateKey(new Date());

  // Одна мапа на місяць. Раніше кожна з 42 клітинок робила власний reduce
  // по всьому масиву подій — 42 повні проходи на кожен рендер календаря.
  const eventsByDate = useMemo(() => {
    const map = {};

    (Array.isArray(dates) ? dates : []).forEach((event) => {
      const key = toDateKey(event.date);
      if (!map[key]) map[key] = [];
      map[key].push(event);
    });

    Object.values(map).forEach((list) => list.sort((a, b) => Number(a.hour) - Number(b.hour)));

    return map;
  }, [dates]);

  const setClasses = (date) => {
    const key = toDateKey(date);
    const classes = [];

    if (key === selectedDate) classes.push('choose-day');
    if (key === today) classes.push('current-day');

    if (markAttendance) {
      const state = dayAttendance(eventsByDate[key] || []);
      if (state) classes.push(`day--${state}`);
    }

    return classes.join(' ');
  };

  return (
    <Calendar
      locale={LOCALE}
      navigationLabel={({ date }) =>
        date.toLocaleDateString(LOCALE, { year: 'numeric', month: 'long' }).replace('р.', '')}
      tileClassName={({ date }) => setClasses(date)}
      tileContent={({ date }) => (
        <ScheduleDay date={date} events={eventsByDate[toDateKey(date)] || []} />
      )}
      maxDetail="month"
      minDetail="month"
      nextLabel=''
      next2Label=''
      prevLabel=''
      prev2Label=''
      activeStartDate={activeStartDate}
      onClickDay={(value) => handleClick(value)}
      onActiveStartDateChange={({ activeStartDate: nextStartDate }) => setActiveStartDate(nextStartDate)}
    />
  );
};

ScheduleMonth.propTypes = {
  dates: PropTypes.array,
  selectedDate: PropTypes.string,
  handleClick: PropTypes.func.isRequired,
  activeStartDate: PropTypes.instanceOf(Date).isRequired,
  setActiveStartDate: PropTypes.func.isRequired,
  markAttendance: PropTypes.bool,
};

ScheduleMonth.defaultProps = {
  dates: [],
  selectedDate: '',
  markAttendance: false,
};

export default ScheduleMonth;
